import { IUser } from '@/interfaces/user'
import { User } from 'containers/user/types/user'

export interface ConnectionRequestDTO {
  profile: User | IUser // TODO: joxxe remove IUser
  message?: string
}

export interface AcceptDeclineConnectionDTO {
  userIdReceivedRequest: string
}

export enum BlockConnectionReason {
  DO_NOT_KNOW = 'do-not-know-user',
  HARASSING_USER = 'harassing-user',
  IMPERSONATING_USER = 'impersonating-user',
  VIOLATING_TERMS = 'violating-terms',
}

export interface BlockConnectionDTO {
  blockedUserId: string
  reason?: BlockConnectionReason
}

export interface UnblockConnectionDTO {
  unblockedUserId: string
}
